import React, { useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import DialogTitleComponent from "../../../../components/dialog_title";
import { TemplateRequest } from "../../../../services/request/reclutamiento/cartas_oferta";
import { MainContext } from "../../../../App";

export default function DialogDelete(props) {
	const {
		is_open,
		data,
		handle_close,
		mutate_cartas_oferta,
	} = props;

	const MainCTX = useContext(MainContext);

	const handleDelete = async () => {
		try {
			await TemplateRequest.Eliminar(data._id);
			MainCTX.ShowSnackbar("Carta de oferta eliminada exitosamente.");
		} catch (error) {
			MainCTX.ShowSnackbar("Error al intentar eliminar la carta de oferta.", error);
		} finally {
			mutate_cartas_oferta();
			handle_close();
		}
	}

	return (
		<Dialog open={is_open} onClose={handle_close} maxWidth="md" PaperProps={{ style: { borderRadius: 20 } }} fullWidth>
			<DialogTitleComponent onClose={handle_close}>Eliminar carta de oferta</DialogTitleComponent>
			<DialogContent>
				<DialogContentText>
					{`Debe confirmar la eliminación de la carta de oferta "${data ? `${data.nombre}` : ""}".`}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handle_close} color="primary">Cancelar</Button>
				<Button onClick={handleDelete} variant="contained" color="primary">Aceptar</Button>
			</DialogActions>
		</Dialog>
	);
}